var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.48999 18.13L2.25999 19.9L12.16 9.99998L2.25999 0.0999756L0.48999 1.86998L8.61999 9.99998L0.48999 18.13Z","fill":"#1B1E1C"}));
}

Arrow.defaultProps = {"width":"13","height":"20","viewBox":"0 0 13 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
